<template>
  <div>
    <a-card>
      <a-table
        row-key="id"
        :data-source="table.data"
        :loading="table.loading"
        style="width: 100%">
        <a-table-column
          data-index="name"
          title="属性"
          width="180">
        </a-table-column>
        <a-table-column
          data-index="code"
          title="编码"
          width="180">
        </a-table-column>
        <a-table-column
          data-index="date"
          :title="$t('OPERATION') || '操作'">
          <template slot-scope="text, record">
            <a-switch v-model="record.isActive" @change="onChange(record)"/>
          </template>
        </a-table-column>
      </a-table>
    </a-card>
    <a-modal
:footer="null"
             append-to-body
             v-model="form.visible">
      <goodsAttribute-edit
        v-if="form.visible"
        :goods-attribute-id="form.data.id"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm">
      </goodsAttribute-edit>
    </a-modal>
  </div>
</template>

<script>
import {
  _queryGoodsAttributes,
  _updateGoodsAttribute,
  _deleteGoodsAttribute,
} from '@/api/goodsAttributeApi';
import GoodsAttributeEdit from './GoodsAttributeEdit.vue';

async function getGoodsAttributeList() {
  this.table.loading = true;
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const result = await _queryGoodsAttributes({
    page: this.table.query.page,
    size: this.table.query.size,
    sort: this.table.sort.prop,
    direction,
  });
  this.table.data = result.content.map(x => ({
    ...x,
    isActive: x.isActive === 'YES',
  }));
  this.table.loading = false;
}

function addGoodsAttribute() {
  this.form.data.id = null;
  this.form.visible = true;
}

function editGoodsAttribute(goodsAttributeId) {
  this.form.data.id = goodsAttributeId;
  this.form.visible = true;
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.getGoodsAttributeList();
}

async function deleteGoodsAttribute(goodsAttributeId) {
  this.$confirm({
    title: '是否删除？',
    content: '',
    onOk: async () => {
      await _deleteGoodsAttribute(goodsAttributeId);
      this.$message.success('删除成功');
    },
  });
}

async function onChange(item) {
  const result = await _updateGoodsAttribute(item.id, {
    isActive: item.isActive ? 'YES' : 'NO',
  });
  if (result) {
    this.$message.success('设置成功');
    await this.getGoodsAttributeList();
  };
}

export default {
  name: 'GoodsAttributeList',
  props: {
    goodsCategoryId: String,
  },
  components: { GoodsAttributeEdit },
  data() {
    return {
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        loading: false,
        data: [],
        query: {
          page: 1,
          size: 100,
          total: 0,
        },
        sort: {
          prop: 'id',
          order: 'descending',
        },
      },
    };
  },
  methods: {
    getGoodsAttributeList,
    deleteGoodsAttribute,
    editGoodsAttribute,
    addGoodsAttribute,
    closeForm,
    onChange,
  },
  created() {
    this.getGoodsAttributeList();
  },
};
</script>

<style scoped>

</style>
